import { capitalize, CurrencyFormat } from "../../../../components/helpers";

export const convertProduct = (code_product, products) => {
  let convertedProduct = [];

  if (!products) return [];

  if (code_product == 1) {
    products.forEach((item, index) => {
      convertedProduct.push({
        id: item.id,
        key: index + 1,
        brand: capitalize(item.brand),
        model: item.model,
        maxPrice: `Rp ${CurrencyFormat(item.max_price)}`,
        minPrice: `Rp ${CurrencyFormat(item.min_price)}`,
        maxPriceNumber: item.max_price,
        minPriceNumber: item.min_price,
      });
    });
  } else if (code_product == 2 || code_product == 3) {
    products.forEach((item, index) => {
      convertedProduct.push({
        id: item.id,
        key: index + 1,
        brand: capitalize(item.brand),
        model: item.model,
        type: item.type,
        year: item.year,
        maxPrice: `Rp ${CurrencyFormat(item.max_price)}`,
        minPrice: `Rp ${CurrencyFormat(item.min_price)}`,
        maxPriceNumber: item.max_price,
        minPriceNumber: item.min_price,
      });
    });
  }
  return convertedProduct;
};
